"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var core_1 = require("@dnd-kit/core");
var modifiers_1 = require("@dnd-kit/modifiers");
var sortable_1 = require("@dnd-kit/sortable");
var utilities_1 = require("@dnd-kit/utilities");
var styles_1 = require("../styles");
var utils_1 = require("../utils");
var hooks_1 = require("../hooks");
var styles = {
    sortableItemStyle: {
        border: "1px solid #f0f0f0",
        margin: "8px 24px",
    },
    sortableItemDragHandle: { marginBottom: 8, cursor: "pointer" },
    sortableItemDragHandleText: { color: "#AAA" },
    listItem: { padding: 12 },
    listItemDescription: { display: "flex", flexDirection: "row", alignItems: "center", gap: 16 },
    helpParagraph: __assign(__assign({}, styles_1.helpText), { marginBottom: 0 }),
    footerDivider: { marginTop: 0 },
    assetSelect: { width: 400 },
};
var SortableItem = react_1.default.memo(function (_a) {
    var _b, _c, _d;
    var id = _a.id, asset = _a.asset, caption = _a.caption, remove = _a.remove, onChangeCaption = _a.onChangeCaption;
    var _e = (0, sortable_1.useSortable)({
        // animateLayoutChanges: () => true,
        id: id,
    }), attributes = _e.attributes, listeners = _e.listeners, setNodeRef = _e.setNodeRef, transform = _e.transform, transition = _e.transition;
    var style = (0, react_1.useMemo)(function () { return (__assign({ transform: utilities_1.CSS.Translate.toString(transform), transition: transition }, styles.sortableItemStyle)); }, [transform, transition]);
    var actions = (0, react_1.useMemo)(function () {
        return [react_1.default.createElement("a", { key: "remove-item", onClick: function () { return remove(id); } }, "Remove")];
    }, [remove]);
    return react_1.default.createElement("div", { ref: setNodeRef, style: style },
        react_1.default.createElement(antd_1.List.Item, { style: styles.listItem, extra: react_1.default.createElement("img", { height: 100, alt: (_b = asset === null || asset === void 0 ? void 0 : asset.file_name) !== null && _b !== void 0 ? _b : "", src: (0, utils_1.assetIdToBytesUrl)(asset === null || asset === void 0 ? void 0 : asset.id) }), actions: actions },
            react_1.default.createElement("div", __assign({}, attributes, listeners, { style: styles.sortableItemDragHandle }),
                react_1.default.createElement(icons_1.DragOutlined, null),
                " ",
                react_1.default.createElement("span", { style: styles.sortableItemDragHandleText }, "Drag to Rearrange")),
            react_1.default.createElement(antd_1.List.Item.Meta, { title: (_c = asset === null || asset === void 0 ? void 0 : asset.file_name) !== null && _c !== void 0 ? _c : "", description: react_1.default.createElement("div", { style: styles.listItemDescription },
                    react_1.default.createElement("span", null,
                        (((_d = asset === null || asset === void 0 ? void 0 : asset.file_size) !== null && _d !== void 0 ? _d : 0) / 1000).toFixed(0),
                        "\u00A0KB"),
                    react_1.default.createElement(antd_1.Input, { value: caption, onChange: function (e) { return onChangeCaption(e.target.value); }, placeholder: "Caption" })) })));
});
var SortableGalleryInputHeader = react_1.default.memo(function () { return react_1.default.createElement("div", null,
    react_1.default.createElement("p", { style: styles.helpParagraph }, "Select image assets to add to the gallery. Added images can then be given a caption and rearranged as desired.")); });
var SortableGalleryInput = react_1.default.memo(function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = (0, react_1.useState)(null), toAdd = _b[0], setToAdd = _b[1];
    var items = value !== null && value !== void 0 ? value : [];
    var itemAssets = (0, react_1.useMemo)(function () { return items.map(function (item) { return item.asset; }); }, [items]);
    var assets = (0, hooks_1.useAppSelector)(function (state) { return state.assets.items.filter(function (a) { return a.asset_type === "image"; }); });
    var assetsByID = (0, react_1.useMemo)(function () { return Object.fromEntries(assets.map(function (a) { return [a.id, a]; })); }, [assets]);
    var imageAssetItems = (0, react_1.useMemo)(function () { return assets
        .filter(function (a) { return items.find(function (i) { return i.asset === a.id; }) === undefined; })
        .map(function (a) { return ({ value: a.id, label: a.file_name }); }); }, [assets]);
    var sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor), (0, core_1.useSensor)(core_1.KeyboardSensor, {
        coordinateGetter: sortable_1.sortableKeyboardCoordinates,
    }));
    var handleDragEnd = (0, react_1.useCallback)(function (_a) {
        var active = _a.active, over = _a.over;
        if (!onChange)
            return;
        if (active.id === over.id)
            return;
        onChange((0, sortable_1.arrayMove)(items, items.findIndex(function (i) { return i.asset === active.id; }), items.findIndex(function (i) { return i.asset === over.id; })));
    }, [onChange, items]);
    var onAssetSelectChange = (0, react_1.useCallback)(function (a) { return setToAdd(a); }, []);
    var onImageAdd = (0, react_1.useCallback)(function () {
        if (!onChange)
            return;
        if (toAdd !== null) {
            onChange(__spreadArray(__spreadArray([], items, true), [{ asset: toAdd, caption: "" }], false));
            setToAdd(null);
        }
    }, [onChange, toAdd]);
    var onItemRemove = (0, react_1.useCallback)(function (asset3) { return onChange(items.filter(function (_a) {
        var asset2 = _a.asset;
        return asset2 !== asset3;
    })); }, [onChange, items]);
    // noinspection JSValidateTypes
    return react_1.default.createElement(antd_1.List, { itemLayout: "vertical", bordered: true, header: react_1.default.createElement(SortableGalleryInputHeader, null), footer: react_1.default.createElement("div", null,
            !!items.length && react_1.default.createElement(antd_1.Divider, { style: styles.footerDivider }),
            react_1.default.createElement(antd_1.Input.Group, { compact: true },
                react_1.default.createElement(antd_1.Select, { style: styles.assetSelect, value: toAdd, onChange: onAssetSelectChange, options: imageAssetItems }),
                react_1.default.createElement(antd_1.Button, { onClick: onImageAdd }, "Add"))) },
        react_1.default.createElement(core_1.DndContext, { sensors: sensors, collisionDetection: core_1.closestCenter, modifiers: [modifiers_1.restrictToVerticalAxis], onDragEnd: handleDragEnd },
            react_1.default.createElement(sortable_1.SortableContext, { items: itemAssets, strategy: sortable_1.verticalListSortingStrategy }, items.map(function (_a) {
                var asset = _a.asset, caption = _a.caption;
                return react_1.default.createElement(SortableItem, { key: asset, id: asset, asset: assetsByID[asset], caption: caption, onChangeCaption: function (newCaption) {
                        return onChange(items.map(function (i) { return i.asset === asset
                            ? { asset: asset, caption: newCaption }
                            : i; }));
                    }, remove: onItemRemove });
            }))));
});
exports.default = SortableGalleryInput;
